import { useMemo } from 'react';
import useOrderProductGridContext from '../../../../../contexts/OrderProductGrid.context';
import { SelloutDistribution } from '../types/selloutDistribution.types';

interface UseSelloutDistributionRowProps {
  distribution: SelloutDistribution[];
}

const useSelloutDistributionRow = ({ distribution }: UseSelloutDistributionRowProps) => {
  const { gridItemSkuIdsErrorAndDisabled } = useOrderProductGridContext();

  const { distributionMap, disabledMap } = useMemo(() => {
    const distributionMap = new Map(distribution.map((item) => [item.skuId, item]));
    const disabledMap = new Map(
      gridItemSkuIdsErrorAndDisabled.map((item) => [item.skuId, item.disabled]),
    );

    return { distributionMap, disabledMap };
  }, [distribution, gridItemSkuIdsErrorAndDisabled]);

  return { distributionMap, disabledMap };
};

export default useSelloutDistributionRow;
